import { FuelButton, FuelToast } from '@frete.com/fuel-react';
import { TOAST_CLOSE_ANIMATION_DURATION, TOAST_TIME_LIMIT } from 'constants/toast';
import { ToastButtonProps } from 'context/ToastProvider/types';
import React, { useEffect, useRef } from 'react';
import { TToastProps } from './types';

export const Toast: React.FC<TToastProps> = ({ heading, message, type, buttonOne, buttonTwo, id, removeToast }) => {
  const toastRef = useRef(null);

  const handleOnButtonClick = (buttonData: ToastButtonProps) => {
    buttonData.onClick?.();
    if (buttonData.closeOnClick) toastRef?.current?.close();
  };

  const handleClose = () =>
    setTimeout(() => {
      removeToast(id);
    }, TOAST_CLOSE_ANIMATION_DURATION);

  useEffect(() => {
    /* istanbul ignore else */
    if (toastRef?.current) {
      toastRef?.current.open();
    }
  }, []);

  return (
    <FuelToast
      ref={toastRef}
      heading={heading}
      message={message}
      severity={type}
      timeLimit={TOAST_TIME_LIMIT}
      onFuel-toast-close={handleClose}
      data-testid={`toast-${id}`}
      position=""
    >
      {buttonOne && (
        <FuelButton
          slot="button"
          variant={buttonOne.variant}
          size={buttonOne.size}
          onClick={() => handleOnButtonClick(buttonOne)}
          data-testid={`toast-${id}-button-one`}
        >
          {buttonOne.text}
        </FuelButton>
      )}

      {buttonTwo && (
        <FuelButton
          slot="button"
          variant={buttonTwo.variant}
          size={buttonTwo.size}
          onClick={() => handleOnButtonClick(buttonTwo)}
          data-testid={`toast-${id}-button-two`}
        >
          {buttonTwo.text}
        </FuelButton>
      )}
    </FuelToast>
  );
};
